import React from 'react';
import { Button, Breakpoint, Constrain, Text } from '@moda/om';
import { CarouselPumoModuleFragment, LookCellFragment } from '../../../generated/types';
import { LooksDesktopModule } from '../LooksDesktopModule';
import { LooksMobileModule } from '../LooksMobileModule';
import { useUrlParams } from '../../../hooks/useUrlParams';

import './EnhancedLooksModuleContent.scss';

interface Props {
  carousel: CarouselPumoModuleFragment;
}

export const EnhancedLooksModuleContent: React.FC<Props> = ({ carousel }) => {
  const looks = carousel.cells as LookCellFragment[];
  const {
    addParams,
    queryParams: { look: selectedLookId }
  } = useUrlParams();

  return (
    <div className="EnhancedLooksModuleContent">
      <Breakpoint lt="sm">
        <LooksMobileModule looks={looks} />
      </Breakpoint>

      <Breakpoint gt="sm">
        <LooksDesktopModule looks={looks} />
      </Breakpoint>

      <Constrain className="EnhancedLooksModuleContent__bottom">
        <Text treatment="body1">
          {looks.length} Look{looks.length === 1 ? '' : 's'}
        </Text>

        <Breakpoint gt="sm">
          <div className="EnhancedLooksModuleContent__shop-by-look">
            <Button
              disabled={selectedLookId != null}
              secondary
              onClick={() => addParams({ look: looks[0].id })}
            >
              Shop by Look
            </Button>
          </div>
        </Breakpoint>
      </Constrain>
    </div>
  );
};
